import {Box} from '@constellation/core';
import {styled} from 'styled-components';

export const StyledBox = styled(Box)`
  .csl-box {
    padding-bottom: 0px;
  }
`;
